import ApiService from './ApiService'

export default class CanoaService extends ApiService {
  constructor() {
    super('https://script.google.com/macros/s/AKfycbw0JeiuKyX30gVvU76ZGmqCAxTGaty23PrWYvb5Uw24DPf9K3Nr/exec')
  }
}



// WEBPACK FOOTER //
// ./src/services/CanoaService.js